<template>
  <div>
    <el-dialog title="绑定钉钉账号" :visible.sync="dialogVisible" width="30%">
      <div id="bind_container"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDingUrl } from '@/api/login.js';
import { removeToken, removeName, removeRoles, getAdminId } from '@/utils/localStorage.js';

export default {
  data() {
    return {
      dialogVisible: false,
      url: '',
    };
  },
  methods: {
    // 绑定钉钉账号
    async bindAcc(id) {
      const adminId = id ? id : getAdminId();
      this.dialogVisible = true;
      const { data } = await getDingUrl({ type: 'bind', admin_id: adminId });
      this.url = data.data.url;
      const goto = encodeURIComponent(this.url);
      const obj = DDLogin({
        id: 'bind_container',
        goto: goto,
        style: 'border:none;background-color:#ffffff;',
        width: '100%',
        height: '340',
      });
      window.addEventListener('message', this.handleMessage, false);
    },
    // 获取登陆后的回调事件
    handleMessage(event) {
      var origin = event.origin;
      if (origin == 'https://login.dingtalk.com') {
        //判断是否来自ddLogin扫码事件。
        var loginTmpCode = event.data;
        //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了

        let reUrl = `${this.url}&loginTmpCode=${loginTmpCode}`;
        removeToken();
        removeName();
        removeRoles();
        console.log(reUrl);
        window.open(reUrl, '_self');
      }
    },
  },
};
</script>

<style>
</style>